import Cookies from "universal-cookie";
import { createReducer } from "reduxsauce";
import CONFIG from "../config";
import Helper from "../helper/Helper";
import Types from "../actions/Types";
import translation from "../translate/en.json";
import translationAr from "../translate/ar.json";

const cookies = new Cookies("");
const localeParam = cookies.get("locale");
let locale = {};

const url = document.URL.replace(/^(?:\/\/|[^\/]+)*\//, "/");
const localeAR = {
  lang: "ar",
  messages: translationAr,
  locale: Helper.getLocale()
};
const localeEN = {
  lang: "en",
  messages: translation,
  locale: Helper.getLocale()
};
if (url === "/") {
  if (cookies.get("lang") && cookies.get("lang") === "ar") {
    locale = localeAR;
  } else {
    locale = localeEN;
  }
} else if (url.indexOf("/ar") !== -1) {
  locale = localeAR;
} else {
  locale = localeEN;
}

Helper.setLocaleCookie(locale);

export const INITIAL_STATE = locale;

function getLocale(state = INITIAL_STATE, newLocale) {
  if (newLocale.data.lang === "ar") {
    return {
      ...state,
      lang: "ar",
      messages: translationAr,
      locale: newLocale.data.locale
    };
  } else {
    return {
      ...state,
      lang: "en",
      messages: translation,
      locale: newLocale.data.locale
    };
  }
}

const ACTION_HANDLERS = {
  [Types.GET_LOCALE]: getLocale
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/reducers/LocaleReducer.js